/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box  } from '@towersystems/towersystems-design-system';
import PrettyPrintJson from 'components/pretty-print-json';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { createCloseModalAction } from 'state/ui/actions';
import { isModalVisible } from 'state/ui/selectors';
import { getResourceConnectId } from 'state/ui/resource-meta-data-modal/selectors';
import { requestResourceConnect  } from 'state/resource-connects/actions';
import Skeleton from 'react-loading-skeleton';

/**
 * Style dependencies
 */
import './styles.scss';

const ResourceMetaDataModal = ({ resourceConnectId, onClosed, isVisible, close, ...props }) => {
   
    const [requesting, setRequesting] = useState(true);
    const [resourceConnect, setResourceConnect] = useState(null);

    useEffect(() => {
        if (resourceConnectId && isVisible) {
            setRequesting(true);
            setResourceConnect(false);
            loadData(resourceConnectId);
        }
    }, [resourceConnectId, isVisible]);

    const loadData = async (id) => {
        try {
            setRequesting(true);
            let result = await props.requestResourceConnect(resourceConnectId);
            setResourceConnect(result);
            setRequesting(false);
        } catch (error) {
            console.log(error);
            close();
        }
    };


    if (!isVisible || !resourceConnectId) {
        return null;
    }

    return (
        <Modal
            onClosed={onClosed}
            className='create-connection-modal'
            close={close}
            isVisible={isVisible}
            title='Resource Metadata'
        >
            <Box padding='large'>{resourceConnect && <PrettyPrintJson data={resourceConnect.meta_data} />}</Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('ResourceMetaDataModal')(state),
        resourceConnectId: getResourceConnectId(state),
    }),
    {
        close: createCloseModalAction('ResourceMetaDataModal'),
        requestResourceConnect,
    },
)(ResourceMetaDataModal);
